// import components
import { Checkbox, Typography } from '@mui/material';
import EventRow from './EventRow';

// import styles
import {
  StyledListViewDivider,
  StyledListViewTableBox,
  StyledListViewTableCheckBox,
  StyledTotalDurationBox
} from './ListViewTable.styles';

// import types
import { ListViewTableProps } from './ListViewTable.types';

// import utils
import { formatHoursMinutes } from 'utils/date';
import { StyledFixedBox40 } from '../ListView.styles';

export default function ListViewTable({
  title,
  columns,
  events,
  selectableEvents,
  onCheckboxChange,
  checked
}: ListViewTableProps) {
  const isSelectable = selectableEvents.length > 0;
  const totalDuration = events.reduce(
    (acc, row) => acc + row.durationInSeconds,
    0
  );

  return (
    <StyledListViewTableBox>
      <StyledListViewTableCheckBox>
        {isSelectable && (
          <Checkbox
            indeterminate={
              selectableEvents.some(({ id }) => checked.includes(id)) &&
              !selectableEvents.every(({ id }) => checked.includes(id))
            }
            checked={selectableEvents.every(({ id }) => checked.includes(id))}
            onChange={(e) =>
              onCheckboxChange(
                e,
                selectableEvents.map(({ id }) => id)
              )
            }
          />
        )}
        {!isSelectable && <StyledFixedBox40 />}
        <Typography>{title}</Typography>
      </StyledListViewTableCheckBox>
      {events.map((event, i) => {
        return (
          <EventRow
            key={`${i}-${event.id}`}
            columns={columns}
            event={event}
            onCheckboxChange={onCheckboxChange}
            checked={checked}
          />
        );
      })}
      <StyledTotalDurationBox>
        {formatHoursMinutes(totalDuration)}
      </StyledTotalDurationBox>
      <StyledListViewDivider />
    </StyledListViewTableBox>
  );
}
